export default "__VITE_ASSET__CELNPKGO__";